import Carousel from "nuka-carousel";
import './LearnerCarouselNew.css';

const LearnerCarouselNew = () => {
    return (
        <Carousel autoplay="true" wrapAround={true} defaultControlsConfig={{
            nextButtonStyle: {'display':'none'},
            prevButtonStyle: {'display':'none'}        
          }}>
                            <div className="main-carousel">
                    <div className="carousel-container">
                        <div className="carousel-wrap">
                            <div className="carousel-row">
                                <div className="carousel-box">
                                <img src="images/home/srisanjanaa_sk.jpg" className='learner-img' alt="image1" /> 
                                    <h2>Srisanjanaa Satishkumar</h2>
                                    {/* <h3>Associate Director</h3> */}
                                    <p>
                                    Excellent Course material with easy access to systems for practice.
                                    Well formulated curriculum and timelines. 
                                    Apart from the course material available for learning, the availability of system to perform hands-on sessions and exercises made it much more fun to continue learning and was helpful in building confidence on the skill.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="carousel-container">
                        <div className="carousel-wrap">
                            <div className="carousel-row">
                                <div className="carousel-box">
                                <img src="images/home/Mauly_sehgal.jpg" className='learner-img' alt="" /> 
                                    <h2>Mauly Sehgal</h2>
                                    {/* <h3>Managing Director</h3> */}
                                    <p>The training material is in-depth and easy to understand. The quizzes between the modules are good to test learnings before the final assessment. Also, the program being self-paced makes it flexible to be completed along with project deliverables. QIP is a great initiative for female employees. A one stop for all the learning needs.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="main-carousel2">
                    <div className="carousel-container">
                        <div className="carousel-wrap">
                            <div className="carousel-row">
                                <div className="carousel-box">
                                <img src="images/home/Meenal_kapoor.png" className='learner-img' alt="" /> 
                                    <h2>Meenal Kapoor</h2>
                                    {/* <h3>Associate Director</h3> */}
                                    <p>I was so very looking forward to SAP trainings as this is the technology which is the most sought after in Japan. Today’s session was a huge learning experience for me, I could connect dots with my current project, appreciate taking all the questions and answering so patiently. It would really help me in my day to day work.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="carousel-container">
                        <div className="carousel-wrap">
                            <div className="carousel-row">
                                <div className="carousel-box">
                                <img src="images/home/srininvas.png" className='learner-img' alt="" /> 
                                    <h2>Srinivas Dhondopant Kulkarni</h2>
                                    {/* <h3>Senior Manager</h3> */}
                                    <p>Being a new Joiner and with no project I had registered myself to understand S4HANA Embedded EWM and I was quite impressed with trainer’s training methodology. The initial videos of how a warehouse looks like was very good and practical idea, rather than jumping directly on the Topic. Trainer brought comfort and interest with practical explanations to all the Consultants who participated.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>            
        </Carousel>
    )   
}

export default LearnerCarouselNew; 